var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"incompleteTemplateView",attrs:{"title":"Incomplete Templates","icon":"tasks"}},[_c('IncompleteTemplateOverview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }